import React from "react";
import { createRoot, type Root } from "react-dom/client";
import Footer from ".";
import { FooterProps } from "./types";

let footerRoot: Root | null = null;

const createFooter = (props: FooterProps) => {
  const footerContainer = document.getElementById("footer");

  if (footerContainer) {
    if (!footerRoot) {
      footerRoot = createRoot(footerContainer);
    }
    footerRoot.render(React.createElement(Footer, props));
  }
};

export { createFooter };
